/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { NetCDFRasterSourcesSinks } from "./NetCDFRasterSourcesSinks";
import {
  NetCDFRasterSourcesSinksFromJSON,
  NetCDFRasterSourcesSinksFromJSONTyped,
  NetCDFRasterSourcesSinksToJSON,
  NetCDFRasterSourcesSinksToJSONTyped,
} from "./NetCDFRasterSourcesSinks";

/**
 *
 * @export
 * @interface PaginatedNetCDFRasterSourcesSinksList
 */
export interface PaginatedNetCDFRasterSourcesSinksList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<NetCDFRasterSourcesSinks>;
}

/**
 * Check if a given object implements the PaginatedNetCDFRasterSourcesSinksList interface.
 */
export function instanceOfPaginatedNetCDFRasterSourcesSinksList(
  value: object
): value is PaginatedNetCDFRasterSourcesSinksList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedNetCDFRasterSourcesSinksListFromJSON(
  json: any
): PaginatedNetCDFRasterSourcesSinksList {
  return PaginatedNetCDFRasterSourcesSinksListFromJSONTyped(json, false);
}

export function PaginatedNetCDFRasterSourcesSinksListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedNetCDFRasterSourcesSinksList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(NetCDFRasterSourcesSinksFromJSON),
  };
}

export function PaginatedNetCDFRasterSourcesSinksListToJSON(
  json: any
): PaginatedNetCDFRasterSourcesSinksList {
  return PaginatedNetCDFRasterSourcesSinksListToJSONTyped(json, false);
}

export function PaginatedNetCDFRasterSourcesSinksListToJSONTyped(
  value?: PaginatedNetCDFRasterSourcesSinksList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(NetCDFRasterSourcesSinksToJSON),
  };
}
